import { REVIEW_STATUS, openTask } from '../../utils/taskClosure';

/**
 * Small badge for task cards: "In review · <reviewer>" while a task waits for
 * approval, "Returned" after a reviewer sent it back. Opens the task popup.
 */
export default function TaskReviewBadge({ task }) {
  const inReview = task?.status === REVIEW_STATUS;
  const returned = !inReview && task?.status !== 'completed' && !!task?.reviewReturnNote;
  if (!inReview && !returned) return null;
  const color = inReview ? 'var(--smc-pu, #a855f7)' : 'var(--smc-am, #f59e0b)';
  return (
    <button type="button" onClick={e => { e.stopPropagation(); openTask(task.id); }}
      title={inReview ? 'Waiting for approval — open' : task.reviewReturnNote}
      style={{ display: 'inline-flex', alignItems: 'center', gap: 4, margin: '0 0 6px', padding: '2px 8px',
        fontFamily: 'var(--smc-mono, monospace)', fontSize: 9, letterSpacing: 0.5, color,
        background: 'transparent', border: `1px solid ${color}`, borderRadius: 10, cursor: 'pointer' }}>
      {inReview ? `⏳ IN REVIEW${task.review?.reviewerName ? ` · ${task.review.reviewerName}` : ''}` : '↩ RETURNED — SEE NOTE'}
    </button>
  );
}
